import React, { useState } from 'react';
import { useTranslation } from '../context/TranslationContext';
import DragNum from './DragNum';
import { IsoArt, pile } from './IsoArt';
import { euro, num } from './Typo';

const WEEKS_PER_YEAR = 46;
const EUROS_PER_CUBE = 250;
const MAX_CUBES = 256;

const COPY = {
  es: {
    title: 'Haz la cuenta',
    lead: 'Cambia los números subrayados: arrástralos o usa las flechas del teclado.',
    s1: 'personas pasan',
    s2: 'horas a la semana haciendo esto a mano. A',
    s3: '€ la hora, son',
    year: 'al año',
    hours: (h) => `Son ${h} horas. Contamos 46 semanas: el año sin vacaciones ni festivos.`,
    save: 'Cuánto te ahorrarías depende del proceso. Lo calculamos en el diagnóstico, que es gratis.',
    cta: 'Pedir el diagnóstico',
    labels: { people: 'Personas', hours: 'Horas a la semana por persona', rate: 'Coste por hora, en euros' },
    art: (n) => `${n} bloques, uno por cada 250 € al año`,
  },
  en: {
    title: 'Do the sum',
    lead: 'Change the underlined numbers: drag them or use the arrow keys.',
    s1: 'people spend',
    s2: 'hours a week doing this by hand. At',
    s3: '€ an hour, that comes to',
    year: 'a year',
    hours: (h) => `${h} working hours. We count 46 weeks: the year minus holidays.`,
    save: 'What you would save depends on the process. We work it out in the diagnosis, which is free.',
    cta: 'Tell us which one it is',
    labels: { people: 'People', hours: 'Hours a week per person', rate: 'Cost per hour in euros' },
    art: (n) => `${n} blocks, one for every €250 a year`,
  },
};

export default function Calculator() {
  const { lang } = useTranslation();
  const c = COPY[lang] || COPY.es;
  const [people, setPeople] = useState(2);
  const [hours, setHours] = useState(6);
  const [rate, setRate] = useState(30);

  const yearHours = people * hours * WEEKS_PER_YEAR;
  const yearCost = yearHours * rate;
  const cubes = Math.max(1, Math.min(MAX_CUBES, Math.round(yearCost / EUROS_PER_CUBE)));

  return (
    <section id="cuenta" className="section" aria-labelledby="cuenta-title">
      <div className="wrap">
        <div className="calc">
          <div>
            <h2 id="cuenta-title" className="t-1">{c.title}</h2>
            <p className="t-small calc-hint">{c.lead}</p>
            <p className="calc-sentence">
              <DragNum value={people} onChange={setPeople} min={1} max={20} label={c.labels.people} /> {c.s1}{' '}
              <DragNum value={hours} onChange={setHours} min={1} max={40} label={c.labels.hours} /> {c.s2}{' '}
              <DragNum value={rate} onChange={setRate} min={10} max={120} step={5} label={c.labels.rate} /> {c.s3}
              <span className="calc-total" aria-live="polite">{euro(yearCost)} <small>{c.year}</small></span>
            </p>
            <div className="calc-foot">
              <p className="t-small">{c.hours(num(yearHours))}</p>
              <p className="t-small">{c.save}</p>
              <p><a className="link" href="#contacto">{c.cta}</a></p>
            </div>
          </div>
          <div className="calc-art">
            <IsoArt voxels={pile(cubes)} frame={[8, 4, 8]} s={30} seams title={c.art(cubes)} />
          </div>
        </div>
      </div>
    </section>
  );
}
